module.exports = __webpack_public_path__ + "img/BINDI 5 PURPLE.f097cff.svg";